requirejs.config({

  "baseUrl": "/site/public/app/",
  "pathsBegin": true,
  "paths": {

    // RequireJS Plugins
    "text": "lib/requirejs/text.min",
    "json": "lib/requirejs/json.min",

    // Lodash
    "lodash": "lib/lodash.min",
    "_": "lib/lodash.extends",
    "lodash416": "lib/lodash.min-4.16",
    // Jquery

    "jquery-deparam": "lib/jquery-deparam.min",
    "jquery-i18n": "lib/jquery.i18n",
    "jquery-maskmoney": "lib/jquery.maskMoney",

    // Angular



    "angular-sanitize": "lib/angular-sanitize.min",
    "angular-storage": "lib/ngStorage.min",
    "bcrypt": "lib/dtrw.bcrypt",
    "oc-lazy-load": "lib/ocLazyLoad.require.min",

    "angular-slider-light":"lib/angular-slider-light/angular-slider-light",

    'tmh-dynamicLocale': 'lib/angular-dynamic-locale/tmhDynamicLocale.min',

    // Angular Directives
    "angular-delay": "directive/angular-delay",

    // "ui-bootstrap-pagination": "directive/ui-bootstrap-pagination",
    "angular-datepicker": "directive/angular-datepicker",
    "angular-auto-numeric": "directive/angular-auto-numeric",
    "angular-input-masks": "directive/angular-input-masks",

    "angular-lightslider":"directive/angular-lightslider",



    "angular-diretivas-site":"directive/angular-diretivas-site",

    // Angular Providers
    "app-route-provider": "provider/app-route-provider",
    "i18n-provider": "provider/i18n-provider",

    // Angular Services
    "config-service": "service/config-service",
    "filter-service": "service/filter-service",
    "currency-service":"service/currency-service",
    "crud-service": "service/crud-service",
    "utils-service": "service/utils-service",
    "anchor-service": "service/anchor-service",
    "notify-service": "service/notify-service",
    "multipart-service": "service/multipart-service",

    // Angular Modules
    "default-module": "../../module/default/public/app/default-module",
    "default-service": "../../module/default/public/app/service/default-service",
    "default-resource": "../../module/default/public/app/resource/default-resource",
    "default-controller": "../../module/default/public/app/controller/default-controller",

    "dashboard-controller": "../../module/dashboard/public/app/controller/dashboard-controller",
    "dashboard-resource": "../../module/dashboard/public/app/resource/dashboard-resource",
    "dashboard-module": "../../module/dashboard/public/app/dashboard-module",

    "contato-controller": "../../module/contato/public/app/controller/contato-controller",
    "contato-module": "../../module/contato/public/app/contato-module",
    "contato-resource": "../../module/contato/public/app/resource/contato-resource",

    "imovelcliente-controller": "../../module/imovelcliente/public/app/controller/imovelcliente-controller",
    "imovelcliente-module": "../../module/imovelcliente/public/app/imovelcliente-module",
    "imovelcliente-resource": "../../module/imovelcliente/public/app/resource/imovelcliente-resource",

    "campanhas-controller": "../../module/campanhas/public/app/controller/campanhas-controller",
    "campanhas-module": "../../module/campanhas/public/app/campanhas-module",
    "campanhas-resource": "../../module/campanhas/public/app/resource/campanhas-resource",

    "imovel-controller": "../../module/imovel/public/app/controller/imovel-controller",
    "imovel-module": "../../module/imovel/public/app/imovel-module",
    "imovel-resource": "../../module/imovel/public/app/resource/imovel-resource",

    "atendimentos-controller": "../../module/atendimentos/public/app/controller/atendimentos-controller",
    "atendimentos-module": "../../module/atendimentos/public/app/atendimentos-module",
    "atendimentos-resource": "../../module/atendimentos/public/app/resource/atendimentos-resource",

    "imovelusuario-controller": "../../module/imovelusuario/public/app/controller/imovelusuario-controller",
    "imovelusuario-module": "../../module/imovelusuario/public/app/imovelusuario-module",
    "imovelusuario-resource": "../../module/imovelusuario/public/app/resource/imovelusuario-resource",

    "pagina-controller": "../../module/pagina/public/app/controller/pagina-controller",
    "pagina-module": "../../module/pagina/public/app/pagina-module",
    "pagina-resource": "../../module/pagina/public/app/resource/pagina-resource",

    "mapa-imoveis-controller": "../../module/mapa-imoveis/public/app/controller/mapa-imoveis-controller",
    "mapa-imoveis-module": "../../module/mapa-imoveis/public/app/mapa-imoveis-module",
    "mapa-imoveis-resource": "../../module/mapa-imoveis/public/app/resource/mapa-imoveis-resource",

    'preview-module': '../../module/preview/public/app/preview-module',
    'preview-service': '../../module/preview/public/app/service/preview-service',



    'simulador-module': "../../module/simulador/public/app/simulador-module",
    'simulador-service': "../../module/simulador/public/app/service/simulador-service",


    "scaffold-module": "../../module/scaffold/public/app/scaffold-module",
    "scaffold-resource": "../../module/scaffold/public/app/resource/scaffold-resource",
    "angular-socialshare": "lib/angular-socialshare-master/angular-socialshare",
    "angular-seo": "lib/angular-seo",
    "ngMeta":"lib/ngMeta",

    "angular-recaptcha":"lib/angular-recaptcha.min",
    "html2canvas":"lib/jspdf/html2canvas",
    "jspdf":"lib/jspdf/jspdf.debug",

    "qrcode":"lib/qrcode/qrcode",
    "qrcode-angular":"lib/qrcode/angular-qr",
/*
     Ruggini - mobile js
*/
    "matchmedia": "lib/matchmedia/matchMedia",
    "matchmediang": "lib/matchmedia/matchmedia-ng",
    "slugifier":"lib/angular-slugify",


    // {{module-installer}}

    "amcharts":"lib/amcharts/amcharts",
    "amcharts-funnel":"lib/amcharts/funnel",
    "amcharts-gantt":"lib/amcharts/gantt",
    "amcharts-gauge":"lib/amcharts/gauge",
    "amcharts-pie":"lib/amcharts/pie",
    "amcharts-radar":"lib/amcharts/radar",
    "amcharts-serial":"lib/amcharts/serial",
    "amcharts-xy":"lib/amcharts/xy",
    "amcharts-theme-light":"lib/amcharts/themes/light",
    'resize':'lib/resize',
    "angular-aria":"lib/angular-aria/angular-aria",
    "angular-animate": "lib/angular-animate/angular-animate.min",


    "fullcalendar": "lib/fullcalendar/fullcalendar",

/*
      Area cliente
     */
    "contestacao-vistoria-controller": "../../module/contestacao-vistoria/public/app/controller/contestacao-vistoria-controller",
    "contestacao-vistoria-module": "../../module/contestacao-vistoria/public/app/contestacao-vistoria-module",
    "contestacao-vistoria-resource": "../../module/contestacao-vistoria/public/app/resource/contestacao-vistoria-resource",
    
    "esteira-locacao-controller": "../../module/esteira-locacao/public/app/controller/esteira-locacao-controller",
    "esteira-locacao-module": "../../module/esteira-locacao/public/app/esteira-locacao-module",
    "esteira-locacao-resource": "../../module/esteira-locacao/public/app/resource/esteira-locacao-resource",
    


    
    "usuario-default-controller": "../../module/usuario-default/public/app/controller/usuario-default-controller",
    "usuario-default-module": "../../module/usuario-default/public/app/usuario-default-module",
    "usuario-default-resource": "../../module/usuario-default/public/app/resource/usuario-default-resource",

    "usuario-dashboard-controller": "../../module/usuario-dashboard/public/app/controller/usuario-dashboard-controller",
    "usuario-dashboard-module": "../../module/usuario-dashboard/public/app/usuario-dashboard-module",
    "usuario-dashboard-resource": "../../module/usuario-dashboard/public/app/resource/usuario-dashboard-resource",

    "usuario-minha-conta-controller": "../../module/usuario-minha-conta/public/app/controller/usuario-minha-conta-controller",
    "usuario-minha-conta-module": "../../module/usuario-minha-conta/public/app/usuario-minha-conta-module",
    "usuario-minha-conta-resource": "../../module/usuario-minha-conta/public/app/resource/usuario-minha-conta-resource",

    "usuario-imoveis-favoritos-controller": "../../module/usuario-imoveis-favoritos/public/app/controller/usuario-imoveis-favoritos-controller",
    "usuario-imoveis-favoritos-module": "../../module/usuario-imoveis-favoritos/public/app/usuario-imoveis-favoritos-module",
    "usuario-imoveis-favoritos-resource": "../../module/usuario-imoveis-favoritos/public/app/resource/usuario-imoveis-favoritos-resource",

    "usuario-solicitacao-interesse-controller": "../../module/usuario-solicitacao-interesse/public/app/controller/usuario-solicitacao-interesse-controller",
    "usuario-solicitacao-interesse-module": "../../module/usuario-solicitacao-interesse/public/app/usuario-solicitacao-interesse-module",
    "usuario-solicitacao-interesse-resource": "../../module/usuario-solicitacao-interesse/public/app/resource/usuario-solicitacao-interesse-resource",

    "usuario-meus-imoveis-controller": "../../module/usuario-meus-imoveis/public/app/controller/usuario-meus-imoveis-controller",
    "usuario-meus-imoveis-module": "../../module/usuario-meus-imoveis/public/app/usuario-meus-imoveis-module",
    "usuario-meus-imoveis-resource": "../../module/usuario-meus-imoveis/public/app/resource/usuario-meus-imoveis-resource",


    "locatario-controller": "../../module/locatario/public/app/controller/locatario-controller",
    "locatario-module": "../../module/locatario/public/app/locatario-module",
    "locatario-resource": "../../module/locatario/public/app/resource/locatario-resource",

    "proprietario-controller": "../../module/proprietario/public/app/controller/proprietario-controller",
    "proprietario-module": "../../module/proprietario/public/app/proprietario-module",
    "proprietario-resource": "../../module/proprietario/public/app/resource/proprietario-resource",

    "chaves-controller": "../../module/chaves/public/app/controller/chaves-controller",
    "chaves-module": "../../module/chaves/public/app/chaves-module",
    "chaves-resource": "../../module/chaves/public/app/resource/chaves-resource",

    "contrato-controller": "../../module/contrato/public/app/controller/contrato-controller",
    "contrato-module": "../../module/contrato/public/app/contrato-module",
    "contrato-resource": "../../module/contrato/public/app/resource/contrato-resource",

    // Main app
    "app": "app",

    // *********************************************
    // This line is replaced with the theme js paths
    // *********************************************
    
    "default-ui": "../../module/default/public/theme/template06/assets/js/default-ui",
    "imovel-ui": "../../module/imovel/public/theme/template06/assets/js/imovel-ui",
    "esteira-ui": "../../module/esteira-locacao/public/theme/template06/assets/js/esteira-ui",
    "angularmap": "../../public/app/directive/angular-map",
    "angular-ui-select": "../../public/theme/template06/assets/plugins/angular-ui-select/js/select",
    "lightslider": "../../public/theme/template06/assets/plugins/lightslider/js/lightslider.min",
    "lightgallery": "../../public/theme/template06/assets/plugins/lightgallery/js/lightgallery",
    "lg-video": "../../public/theme/template06/assets/plugins/lightgallery/js/lg-video",
    "moment": "../../public/theme/template06/assets/plugins/fullcalendar/lib/moment.min",
    "angular-file-upload": "../../public/theme/template02/assets/plugins/angular-file-upload/ng-file-upload",
    "jquery-inputmask": "../../public/theme/template02/assets/plugins/jquery-inputmask/jquery.inputmask.min"

  },
  "pathsEnd": true,
  "shimBegin": true,
  shim: {
    "_": ["lodash"],
    "app": [],
    "jquery-deparam": [],
    "jquery-i18n": [],
    "angular": [],
    "oc-lazy-load": [],
    "angular-route": [],
    "angular-sanitize": [],
    "angular-input-masks":["jquery-maskmoney"],
    "angular-auto-numeric":[],
    //"angular-animate":[],
    "matchmedia":[],
    "matchmediang":["matchmedia"],
    "angular-socialshare":[],
    "ngMeta":[],
    "filter-service": ["angular-sanitize"],
    "tmh-dynamicLocale":[],
    "slugifier":[],
    "angular-lightslider":["lightslider"],
    "angular-recaptcha":[],
    "jspdf":["html2canvas"],
    "qrcode-angular":["qrcode"],
    "angular-seo":[],
    "amcharts":[],
    "amcharts-theme-light":["amcharts"],
    "amcharts-funnel":["amcharts", "amcharts-theme-light"],
    "amcharts-gantt": ["amcharts", "amcharts-theme-light"],
    "amcharts-gauge": ["amcharts", "amcharts-theme-light"],
    "amcharts-pie": ["amcharts", "amcharts-theme-light"],
    "amcharts-radar": ["amcharts", "amcharts-theme-light"],
    "amcharts-serial": ["amcharts", "amcharts-theme-light"],
    "amcharts-xy": ["amcharts", "amcharts-theme-light"],
    // "angular-material":['angular', 'angular-aria', 'angular-animate'],


    // ********************************************
    // This line is replaced with the theme js shim
    // ********************************************
    
    "jquery-inputmask": [],
    "jquery-autonumeric": [],
    "lightslider": [],
    "angular-ui-select": [],
    "angularmap": [],
    "lightgallery": [],
    "lg-video": [
        "lightgallery"
    ],
    "flot": [],
    "flot-resize": [
        "flot"
    ],
    "angular-file-upload": []


  },
  "shimEnd": true

});

// Start the main app logic.
requirejs(["app"], function() {
  angular.bootstrap(document, ["app"]);
})

// // Carregar scripts de performance e inicializar o gerenciador de tarefas
// require([], function () {
//     // Registrar Service Worker
//     if ('serviceWorker' in navigator) {
//         window.addEventListener('load', function () {
//             navigator.serviceWorker.register('/site/public/sw.js')
//                 .then(function (registration) {
//                     // console.log('[ServiceWorker] Registrado com sucesso: ', registration.scope);
//                 })
//                 .catch(function (error) {
//                     console.error('[ServiceWorker] Falha no registro: ', error);
//                 });
//         });
//     }
// });

define("main", function(){});

